import PropTypes from 'prop-types';
import React, { useState } from 'react';
import * as R from 'ramda';
import { FormLabel, FormGroup } from 'react-bootstrap';

import MedicationManagement from 'App/components/MedicationManagement/MedicationManagement';
import PlaceHolderMessage from 'App/components/styles/PlaceholderMessage/PlaceHolderMessage';
import { SelectInput } from 'Shared/form/SelectField';

const propTypes = {
    therapies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const defaultProps = {
};

function TherapySearch({ therapies }) {
    const [searchValue, setSearchValue] = useState(null);

    return (
        <div>
            <FormGroup style={{ width: '500px' }}>
                <FormLabel htmlFor="therapy-select">Select a Therapy</FormLabel>
                <SelectInput
                    options={therapies}
                    getOptionValue={R.prop('id')}
                    getOptionLabel={R.prop('name')}
                    name="therapy-select"
                    value={searchValue}
                    onChange={(option) => {
                        setSearchValue(option);
                    }}
                />
            </FormGroup>
            {searchValue ? (
                <MedicationManagement searchValue={[searchValue.id]} searchType="therapy" />
            ) : (
                <PlaceHolderMessage placeholderText="Select a therapy." />
            )}
        </div>
    );
}

TherapySearch.propTypes = propTypes;
TherapySearch.defaultProps = defaultProps;

export default TherapySearch;
